var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import DataLayer from "@lonelyplanet/dotcom-core/dist/containers/dataLayer";
import { poiTypes } from "@lonelyplanet/dotcom-routing/dist/details/constants";
import { Helmet } from "@lonelyplanet/travel-agent/dist/helmet";
import { Heading } from "backpack-ui/dist/components/text";
import * as React from "react";
import { Ad, AdUnit } from "../../shared/components/ad";
import Template from "../../shared/components/template";
import Text from "../../shared/components/text";
import Breadcrumbs from "../../shared/patterns/breadcrumbs";
import { MapInteractiveAsync as Map } from "./components/map/mapInteractiveAsync";
import SuggestEdit from "./components/suggestEdit";
import MultiLine from "./components/multiLine";
import Activities from "./patterns/activities";
import Booking from "./patterns/booking";
import Description from "./patterns/description";
import Header from "./patterns/header";
import Hero from "./patterns/hero";
import Info from "./patterns/info";
import Review from "./patterns/review";
import * as styles from "./styles/pois.css";
import TemplatePoiDetail from "./templates/detail";
import { createAdTargeting } from "./utils/createAdTargeting";
import { formatAddressExtras } from "./utils/formatAddressExtras";
import { getDistanceToCityCenter } from "./utils/getDistanceToCityCenter";
import { getProviderUrl } from "./utils/providerLinkBuilder";
import { cleanPartnerDescriptions } from "./utils/cleanPartnerDescriptions";
import heroImageSizes from "./utils/heroImageSizes";
import hotelProvider from "./utils/hotelProvider";
import lodgingFacilities from "./utils/lodgingFacilities";
import { viatorMoreLink } from "./utils/providerLinkBuilder";
import sortMainImagesToFront from "./utils/sortMainImagesToFront";
import filterSmallImages from "./utils/filterSmallImages";
import { analytics, DataLayerInitializationData, DestinationSubNavs, } from "@lonelyplanet/lp-analytics";
var PageLodging = /** @class */ (function (_super) {
    __extends(PageLodging, _super);
    function PageLodging() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isTopChoice = _this.props.poi.attributes &&
            _this.props.poi.attributes.length &&
            _this.props.poi.attributes[0].name === "top_choice";
        _this.hasProviders = _this.props.poi.providers &&
            PageLodging.hasLength(_this.props.poi.providers);
        _this.hasPartnerDescription = _this.hasProviders &&
            _this.props.poi.providers[0].description &&
            PageLodging.hasLength(_this.props.poi.providers[0].description);
        _this.hasFacilities = _this.hasProviders &&
            _this.props.poi.providers[0].facilities &&
            PageLodging.hasLength(_this.props.poi.providers[0].facilities);
        _this.hasImages = _this.props.poi.images &&
            PageLodging.hasLength(_this.props.poi.images);
        _this.hasMainImageAttributions = _this.hasImages &&
            Array.isArray(_this.props.poi.images[0].attribution) &&
            PageLodging.hasLength(_this.props.poi.images[0].attribution);
        _this.hasActivities = _this.props.related &&
            PageLodging.hasLength(_this.props.related);
        _this.provider = hotelProvider(_this.props.poi.providers);
        _this.hasNearbyPlaces = function () { return _this.props.nearbyMapMarkers && PageLodging.hasLength(_this.props.nearbyMapMarkers); };
        return _this;
    }
    PageLodging.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, breadcrumbs = _b.breadcrumbs, poi = _b.poi, places = _b.places, activities = _b.related, isDOM = _b.isDOM, dataLayer = _b.dataLayer, location = _b.location, bookmarked = _b.bookmarked, onClickBookmark = _b.onClickBookmark, match = _b.match, related = _b.related;
        var subtype = poiTypes[poi.poiType.toLowerCase()].displayName;
        var metaImage = this.hasImages ? poi.images[0].url : "";
        var poiAtlas = poi.poi;
        var moreTourLink = related.length > 0 && viatorMoreLink(__assign({}, related[0], {
            containingPlaceId: match.params.placeId,
            containingPlaces: poi.containingPlaces,
        }));
        var cleanDescriptions = this.hasPartnerDescription
            ? cleanPartnerDescriptions(this.provider.type, this.provider.data.description)
            : [];
        /**
         * If this lodging has images, in order:
         * 1.) Filter out small, pixelated images.
         * 2.) Move images that
         *   a.) have tags, and
         *   b.) among them, have the "main" tag
         *   to the front.
         */
        var filteredImages = this.hasImages &&
            sortMainImagesToFront(filterSmallImages(poi.images));
        var adTargeting = createAdTargeting(dataLayer);
        return (React.createElement(React.Fragment, null,
            React.createElement(Helmet, null,
                React.createElement("meta", { property: "og:image", content: metaImage }),
                React.createElement("meta", { className: "swiftype", name: "op-parent-id", "data-type": "string", content: poi.containingCityId }),
                React.createElement("meta", { className: "swiftype", name: "op-parent-name", "data-type": "string", content: poi.containingCityName }),
                React.createElement("meta", { className: "swiftype", name: "op-subtype", "data-type": "string", content: subtype }),
                React.createElement("meta", { className: "swiftype", name: "op-type-lodging", "data-type": "integer", content: "100" }),
                React.createElement("meta", { className: "swiftype", name: "top-choice", "data-type": "integer", content: this.isTopChoice ? "1" : "0" }),
                React.createElement("meta", { className: "swiftype", name: "grade", "data-type": "float", content: (poi.lpInternalScore && poi.lpInternalScore.toString()) || "0" }),
                React.createElement("meta", { className: "swiftype", name: "thumbnail", "data-type": "string", content: metaImage })),
            React.createElement(DataLayer, { data: {
                    cd26_PartnerOfferingDetails: poi.name,
                    cd27_PartnerOfferingKind: subtype,
                    cd28_PartnerName: this.provider && this.provider.name,
                    kind: subtype,
                    subtypes: poi.subtypes.join(", "),
                } }),
            React.createElement(DataLayerInitializationData, { data: (_a = {},
                    _a[analytics.atlasId] = poiAtlas && poiAtlas.id,
                    _a[analytics.contentCity] = poi.containingCityName,
                    _a[analytics.contentContinent] = poi.containingContinentName,
                    _a[analytics.contentCountry] = poi.containingCountryName,
                    _a[analytics.contentNeighborhood] = poi.containingNeighborhoodName,
                    _a[analytics.contentRegion] = poi.containingRegionNames && poi.containingRegionNames.join(", "),
                    _a[analytics.destinationSubNav] = DestinationSubNavs.hotels,
                    _a[analytics.poiAttributes] = poiAtlas &&
                        poiAtlas.poiAttributes &&
                        poiAtlas.poiAttributes.map(function (_a) {
                            var category = _a.category, name = _a.name;
                            return "{ " + category + ": " + name + " }";
                        }).join(", "),
                    _a[analytics.poiName] = poi.name,
                    _a[analytics.poiType] = poi.type,
                    _a), indexForEntirePayload: 1 }),
            React.createElement(TemplatePoiDetail, null,
                React.createElement(Template.Position, { area: "breadcrumbs" },
                    React.createElement(Breadcrumbs, { className: styles.breadcrumbs, links: breadcrumbs })),
                React.createElement(Template.Position, { area: "header" },
                    React.createElement(Header, { title: poi.name, type: poi.subtypes[0], location: poi.containingPlaceName, topChoice: this.isTopChoice, bookmarked: bookmarked, onClickBookmark: onClickBookmark })),
                this.hasImages &&
                    React.createElement(Template.Position, { area: "hero" },
                        filteredImages.length === 1 &&
                            React.createElement(Hero.Photo, { src: filteredImages[0].url, sizes: heroImageSizes.single.main }),
                        filteredImages.length > 1 &&
                            React.createElement(Hero.Gallery, { images: filteredImages.map(function (image) { return image.url; }), imageSize: {
                                    height: 460,
                                    width: 840,
                                } })),
                this.hasMainImageAttributions &&
                    React.createElement(Template.Position, { area: "heroAttribution" },
                        React.createElement(Hero.Attribution, { attributions: filteredImages[0].attribution })),
                poi.review && poi.review.essential &&
                    React.createElement(Template.Position, { area: "reviewEssential" },
                        React.createElement(Review.Essential, null,
                            React.createElement(Text.Html, null, poi.review.essential))),
                poi.review && poi.review.extension &&
                    React.createElement(Template.Position, { area: "reviewExtension" },
                        React.createElement(Review.Extension, null,
                            React.createElement(Text.Html, null, poi.review.extension))),
                (poiAtlas &&
                    poiAtlas.location &&
                    poiAtlas.location.coordinates &&
                    poiAtlas.location.coordinates.length) &&
                    this.hasNearbyPlaces() &&
                    React.createElement(Template.Position, { area: "map" }, isDOM &&
                        React.createElement(Map, { center: {
                                coordinates: poiAtlas.location.coordinates.slice(0).reverse(),
                                name: poi.name,
                            }, markers: this.props.nearbyMapMarkers })),
                this.hasPartnerDescription &&
                    React.createElement(Template.Position, { area: "descriptionPartner" }, cleanDescriptions.map(function (item, index) { return (React.createElement(Description, { key: item.title },
                        React.createElement(Description.Heading, null,
                            item.title,
                            " ",
                            index === 0 && React.createElement("a", { href: getProviderUrl({}, __assign({}, _this.provider.data)), target: "_blank", rel: "noopener" },
                                "via ",
                                _this.provider.name)),
                        React.createElement(Description.Text, null,
                            React.createElement(MultiLine, { text: item.text })))); })),
                this.hasFacilities &&
                    React.createElement(Template.Position, { area: "activityFeatures" },
                        React.createElement(Description, null,
                            React.createElement(Description.Heading, null,
                                "Features of ",
                                poi.name),
                            React.createElement(Description.Columns, null, lodgingFacilities(this.provider.data.facilities).map(function (group) { return (React.createElement(Description.Column, { key: group.title },
                                React.createElement(Description.ColumnHeading, null, group.title),
                                React.createElement(Description.Text, null,
                                    React.createElement("ul", null, group.items.map(function (item) { return (React.createElement("li", { key: item }, item)); }))))); })))),
                this.hasProviders &&
                    React.createElement(Template.Position, { area: "callToActionMobile" },
                        React.createElement(Booking.AvailabilityFetcher, { lodgingId: poi.id, provider: this.provider.data, render: function (_a) {
                                var dates = _a.dates, focusedInput = _a.focusedInput, handleDateChange = _a.handleDateChange, handleFocusChange = _a.handleFocusChange, price = _a.price, nights = _a.nights, url = _a.url, unavailable = _a.unavailable, loading = _a.loading;
                                return (React.createElement(Booking.Lodging, { loading: loading, unavailable: unavailable, dates: dates, 
                                    // TODO: get with OP to get the proper hostelworld score
                                    rating: _this.provider.data.score <= 10 ? _this.provider.data.score + " out of 10" : "", providerName: _this.provider.name && _this.provider.name.toLowerCase(), providerType: _this.provider.type, lodgingName: poi.name, nights: nights, handleDateChange: handleDateChange, handleFocusChange: handleFocusChange, focusedInput: focusedInput, price: price, url: url }));
                            } })),
                this.hasProviders &&
                    React.createElement(Template.Position, { area: "callToActionAside" },
                        React.createElement(Booking.AvailabilityFetcher, { lodgingId: poi.id, provider: this.provider.data, render: function (_a) {
                                var dates = _a.dates, focusedInput = _a.focusedInput, handleDateChange = _a.handleDateChange, handleFocusChange = _a.handleFocusChange, price = _a.price, nights = _a.nights, url = _a.url, unavailable = _a.unavailable, loading = _a.loading;
                                return (React.createElement(Booking.Lodging, { loading: loading, unavailable: unavailable, dates: dates, 
                                    // TODO: get with OP to get the proper hostelworld score
                                    rating: _this.provider.data.score <= 10 ? _this.provider.data.score + " out of 10" : "", providerName: _this.provider.name && _this.provider.name.toLowerCase(), providerType: _this.provider.type, lodgingName: poi.name, nights: nights, handleDateChange: handleDateChange, handleFocusChange: handleFocusChange, focusedInput: focusedInput, price: price, url: url }));
                            } })),
                React.createElement(Template.Position, { area: "infoLocation" },
                    React.createElement(Info, null,
                        React.createElement(Info.Heading, null, "Overview"),
                        (poi.location && poi.location.coordinates && poi.location.coordinates.length) &&
                            React.createElement(Info.Map, { coordinates: poi.location.coordinates.join(",") }),
                        (poi.address && poi.address.street) &&
                            React.createElement(Info.Item, null, poi.address.street),
                        (poi.address && poi.address.extras) &&
                            React.createElement(React.Fragment, null, formatAddressExtras(poi.address.extras).map(function (item) { return (React.createElement(Info.Item, { label: item.label }, item.text)); })),
                        (poi.location && poi.location.coordinates && poi.location.coordinates.length) &&
                            React.createElement(Info.Item, null, getDistanceToCityCenter(poi.location.coordinates, places)),
                        (poiAtlas && poiAtlas.telephone && poiAtlas.telephone.national) &&
                            React.createElement(Info.Item, null,
                                React.createElement("a", { href: "tel:" + (poiAtlas.telephone.callingCode || "") +
                                        ("" + poiAtlas.telephone.national.replace(/-|\s/g, "")) }, poiAtlas.telephone.national)),
                        (poiAtlas && poiAtlas.emails && poiAtlas.emails.length) &&
                            React.createElement(Info.Item, null, Array.isArray(poiAtlas.emails) ? poiAtlas.emails[0] : poiAtlas.emails),
                        poiAtlas && poiAtlas.website &&
                            React.createElement(Info.Item, null,
                                React.createElement("a", { href: poiAtlas.website }, "Visit website")))),
                poi.review && poi.review.essential && (React.createElement(Template.Position, { area: "suggestEdit" },
                    React.createElement(SuggestEdit, { poi: poi, location: location }))),
                this.hasActivities &&
                    React.createElement(Template.Position, { area: "activitiesLodging" },
                        React.createElement("div", null,
                            React.createElement(Heading, { size: 7, level: 4, weight: "medium" }, "Nearby activities"),
                            React.createElement(Activities, { data: activities, url: moreTourLink, containingPlaces: poi.containingPlaces, placeId: match.params.placeId, parentActivityName: poi.name, buttonColor: "gray" }))),
                React.createElement(Template.Position, { area: "adRail" },
                    React.createElement(Ad.Primary, null,
                        React.createElement(AdUnit.SideRail, { adUnit: "poisRightRail", targeting: adTargeting }))),
                React.createElement(Template.Position, { area: "adSuperzone" },
                    React.createElement(Ad.Bounded, null,
                        React.createElement(AdUnit.Superzone, { adUnit: "poisSuperzone", targeting: adTargeting }))))));
    };
    PageLodging.hasLength = function (array) { return array.length > 0; };
    return PageLodging;
}(React.Component));
export default PageLodging;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/lodging.tsx
// module id = TGOE
// module chunks = 2